module.exports = __webpack_public_path__ + "static/img/fitness17.3f09cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/fitness17.png
// module id = KUy5
// module chunks = 1